var SV_ES = ((document.documentElement && document.documentElement.lang) || '').slice(0, 2) === 'es';
(function () {
  if (window.SV_CART_DRAWER_LOADED) return;
  window.SV_CART_DRAWER_LOADED = true;

  function rootUrl() {
    return window.Shopify && Shopify.routes && Shopify.routes.root
      ? Shopify.routes.root
      : '/';
  }

  function buildUrl(path) {
    return rootUrl().replace(/\/$/, '') + '/' + path.replace(/^\//, '');
  }

  function money(cents, currency) {
    var amount = Number(cents || 0) / 100;

    try {
      return new Intl.NumberFormat('es-ES', {
        style: 'currency',
        currency: currency || 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (e) {
      return '€' + amount.toFixed(2);
    }
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function injectStyles() {
    if (document.getElementById('sv-cart-drawer-styles')) return;

    var style = document.createElement('style');
    style.id = 'sv-cart-drawer-styles';
    style.textContent = `
      .sv-cart-overlay {
        position: fixed;
        inset: 0;
        background: rgba(0, 0, 0, 0.42);
        opacity: 0;
        visibility: hidden;
        z-index: 9998;
        transition: opacity 220ms ease, visibility 220ms ease;
      }

      .sv-cart-overlay.is-open {
        opacity: 1;
        visibility: visible;
      }

      .sv-cart-drawer {
        position: fixed;
        top: 0;
        right: 0;
        width: min(520px, 100vw);
        height: 100vh;
        background: #fff;
        z-index: 9999;
        transform: translateX(100%);
        transition: transform 280ms cubic-bezier(.2,.8,.2,1);
        display: flex;
        flex-direction: column;
        box-shadow: -18px 0 50px rgba(0,0,0,.16);
      }

      .sv-cart-drawer.is-open {
        transform: translateX(0);
      }

      .sv-cart-drawer__header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 28px 32px;
        border-bottom: 1px solid rgba(0,0,0,.08);
      }

      .sv-cart-drawer__title {
        margin: 0;
        font-size: 30px;
        line-height: 1;
        font-weight: 900;
        letter-spacing: -0.04em;
      }

      .sv-cart-drawer__count {
        font-size: 14px;
        vertical-align: super;
        margin-left: 4px;
      }

      .sv-cart-drawer__close {
        width: 44px;
        height: 44px;
        border-radius: 999px;
        border: 1px solid rgba(0,0,0,.1);
        background: #fff;
        cursor: pointer;
        font-size: 26px;
        line-height: 1;
      }

      .sv-cart-drawer__body {
        flex: 1;
        overflow-y: auto;
        padding: 26px 32px;
      }

      .sv-cart-empty {
        padding: 50px 0;
        text-align: center;
        color: rgba(0,0,0,.6);
        font-weight: 600;
      }

      .sv-cart-free-shipping {
        margin-bottom: 26px;
      }

      .sv-cart-free-shipping__text {
        font-size: 14px;
        margin-bottom: 10px;
        color: #111;
      }

      .sv-cart-free-shipping__bar {
        height: 6px;
        background: rgba(0,0,0,.08);
        border-radius: 999px;
        overflow: hidden;
      }

      .sv-cart-free-shipping__fill {
        display: block;
        height: 100%;
        width: 0%;
        background: #111;
        border-radius: 999px;
      }

      .sv-cart-item {
        display: grid;
        grid-template-columns: 82px 1fr auto;
        gap: 16px;
        padding: 18px 0;
        border-bottom: 1px solid rgba(0,0,0,.08);
      }

      .sv-cart-item__image {
        width: 82px;
        height: 82px;
        border-radius: 10px;
        background: #f6f6f6;
        object-fit: contain;
      }

      .sv-cart-item__title {
        display: block;
        color: #111;
        text-decoration: none;
        font-weight: 800;
        font-size: 15px;
        line-height: 1.25;
        margin-bottom: 4px;
      }

      .sv-cart-item__variant {
        color: rgba(0,0,0,.55);
        font-size: 13px;
        margin-bottom: 8px;
      }

      .sv-cart-item__price {
        font-size: 14px;
        font-weight: 700;
      }

      .sv-cart-item__controls {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        gap: 10px;
      }

      .sv-cart-qty {
        display: grid;
        grid-template-columns: 28px 34px 28px;
        align-items: center;
        height: 38px;
        background: #f7f7f7;
        border-radius: 10px;
        overflow: hidden;
      }

      .sv-cart-qty button {
        border: 0;
        background: transparent;
        cursor: pointer;
        font-size: 18px;
        height: 38px;
      }

      .sv-cart-qty span {
        text-align: center;
        font-weight: 700;
        font-size: 14px;
      }

      .sv-cart-remove {
        border: 0;
        background: transparent;
        padding: 0;
        text-decoration: underline;
        cursor: pointer;
        font-size: 13px;
        color: rgba(0,0,0,.7);
      }

      .sv-cart-drawer__footer {
        border-top: 1px solid rgba(0,0,0,.08);
        padding: 22px 32px 28px;
        background: #fff;
      }

      .sv-cart-subtotal {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        margin-bottom: 18px;
      }

      .sv-cart-subtotal__label {
        font-size: 14px;
        color: rgba(0,0,0,.7);
      }

      .sv-cart-subtotal__price {
        font-size: 24px;
        font-weight: 900;
        color: #111;
      }

      .sv-cart-actions {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 12px;
      }

      .sv-cart-checkout,
      .sv-cart-view {
        min-height: 54px;
        border-radius: 999px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-decoration: none;
        font-weight: 900;
        font-size: 15px;
      }

      .sv-cart-checkout {
        background: #111;
        color: #fff;
      }

      .sv-cart-view {
        background: #fff;
        color: #111;
        border: 1px solid #111;
      }

      body.sv-cart-open {
        overflow: hidden;
      }

      @media screen and (max-width: 749px) {
        .sv-cart-drawer {
          width: 100vw;
        }

        .sv-cart-drawer__header,
        .sv-cart-drawer__body,
        .sv-cart-drawer__footer {
          padding-left: 20px;
          padding-right: 20px;
        }

        .sv-cart-actions {
          grid-template-columns: 1fr;
        }

        .sv-cart-item {
          grid-template-columns: 72px 1fr;
        }

        .sv-cart-item__controls {
          grid-column: 1 / -1;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
        }

        .sv-cart-item__image {
          width: 72px;
          height: 72px;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function injectDrawer() {
    if (document.querySelector('[data-sv-cart-drawer]')) return;

    var overlay = document.createElement('div');
    overlay.className = 'sv-cart-overlay';
    overlay.setAttribute('data-sv-cart-overlay', '');

    var drawer = document.createElement('aside');
    drawer.className = 'sv-cart-drawer';
    drawer.setAttribute('data-sv-cart-drawer', '');
    drawer.setAttribute('aria-hidden', 'true');

    drawer.innerHTML = `
      <div class="sv-cart-drawer__header">
        <h2 class="sv-cart-drawer__title">
          ${SV_ES ? 'Carrito' : 'Cart'}
        </h2>

        <button type="button" class="sv-cart-drawer__close" data-sv-cart-close aria-label="${SV_ES ? 'Cerrar carrito' : 'Close cart'}">
          ×
        </button>
      </div>

      <div class="sv-cart-drawer__body" data-sv-cart-body>
        <div class="sv-cart-empty">${SV_ES ? 'Tu carrito está vacío.' : 'Your cart is empty.'}</div>
      </div>

      <div class="sv-cart-drawer__footer" data-sv-cart-footer>
        <div class="sv-cart-subtotal">
          <span class="sv-cart-subtotal__label">${SV_ES ? 'Subtotal' : 'Subtotal'}</span>
          <span class="sv-cart-subtotal__price" data-sv-cart-subtotal>€0.00</span>
        </div>

        <div class="sv-cart-actions">
          <a class="sv-cart-checkout" href="${buildUrl('checkout')}">${SV_ES ? 'Pagar' : 'Check out'}</a>
          <a class="sv-cart-view" href="${buildUrl('cart')}">${SV_ES ? 'Ver carrito' : 'View cart'}</a>
        </div>
      </div>
    `;

    document.body.appendChild(overlay);
    document.body.appendChild(drawer);
  }

  function openDrawer() {
    var drawer = document.querySelector('[data-sv-cart-drawer]');
    var overlay = document.querySelector('[data-sv-cart-overlay]');

    if (!drawer || !overlay) return;

    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('sv-cart-open');
  }

  function closeDrawer() {
    var drawer = document.querySelector('[data-sv-cart-drawer]');
    var overlay = document.querySelector('[data-sv-cart-overlay]');

    if (!drawer || !overlay) return;

    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('sv-cart-open');
  }

  function fetchCart() {
    return fetch(buildUrl('cart.js') + '?t=' + Date.now(), {
      method: 'GET',
      cache: 'no-store',
      headers: {
        Accept: 'application/json'
      }
    }).then(function (res) {
      if (!res.ok) throw new Error('Could not fetch cart');
      return res.json();
    });
  }

  function updateHeaderCount(cart) {
    var count = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;

    document.querySelectorAll('[data-cart-count], .cart-count-bubble span, #cart-icon-bubble span').forEach(function (el) {
      el.textContent = count;
    });

    document.querySelectorAll('.cart-count-bubble').forEach(function (bubble) {
      bubble.classList.toggle('hidden', count === 0);
      bubble.style.display = count > 0 ? '' : 'none';
    });
  }

  function renderCart(cart) {
    var body = document.querySelector('[data-sv-cart-body]');
    var subtotal = document.querySelector('[data-sv-cart-subtotal]');
    var count = document.querySelector('[data-sv-drawer-count]');
    var currency = cart.currency || 'EUR';

    if (!body || !subtotal) return;

    if (count) {
      count.textContent = cart.item_count || 0;
    }

    subtotal.textContent = money(cart.total_price, currency);

    if (!cart.items || cart.items.length === 0) {
      body.innerHTML = (SV_ES ? '<div class="sv-cart-empty">Tu carrito está vacío.</div>' : '<div class="sv-cart-empty">Your cart is empty.</div>');
      updateHeaderCount(cart);
      return;
    }

    var freeShippingThreshold = 10000;
    var remaining = Math.max(freeShippingThreshold - cart.total_price, 0);
    var progress = Math.min((cart.total_price / freeShippingThreshold) * 100, 100);

    var html = `
      <div class="sv-cart-free-shipping">
        <div class="sv-cart-free-shipping__text">
          ${
            remaining > 0
              ? (SV_ES ? 'Te faltan <strong>' : 'Spend <strong>') + money(remaining, currency) + (SV_ES ? '</strong> para el envío gratis.' : '</strong> more to reach free shipping!')
              : (SV_ES ? '<strong>¡Ya tienes envío gratis!</strong>' : '<strong>You unlocked free shipping!</strong>')
          }
        </div>
        <div class="sv-cart-free-shipping__bar">
          <span class="sv-cart-free-shipping__fill" style="width:${progress}%"></span>
        </div>
      </div>
    `;

    cart.items.forEach(function (item, index) {
      var image = item.image || '';
      var title = item.product_title || item.title || '';
      var url = item.url || '#';
      var variant = item.variant_title && item.variant_title !== 'Default Title'
        ? item.variant_title
        : '';

      html += `
        <div class="sv-cart-item" data-cart-line="${index + 1}">
          ${
            image
              ? '<img class="sv-cart-item__image" src="' + escapeHtml(image) + '" alt="' + escapeHtml(title) + '">'
              : '<div class="sv-cart-item__image"></div>'
          }

          <div class="sv-cart-item__info">
            <a class="sv-cart-item__title" href="${escapeHtml(url)}">
              ${escapeHtml(title)}
            </a>

            ${
              variant
                ? '<div class="sv-cart-item__variant">' + escapeHtml(variant) + '</div>'
                : ''
            }

            <div class="sv-cart-item__price">
              ${money(item.final_line_price, currency)}
            </div>
          </div>

          <div class="sv-cart-item__controls">
            <div class="sv-cart-qty">
              <button type="button" data-sv-cart-change="${index + 1}" data-qty="${Math.max(item.quantity - 1, 0)}">−</button>
              <span>${item.quantity}</span>
              <button type="button" data-sv-cart-change="${index + 1}" data-qty="${item.quantity + 1}">+</button>
            </div>

            <button type="button" class="sv-cart-remove" data-sv-cart-change="${index + 1}" data-qty="0">
              ${SV_ES ? 'Quitar' : 'Remove'}
            </button>
          </div>
        </div>
      `;
    });

    body.innerHTML = html;
    updateHeaderCount(cart);
  }

  function changeCartLine(line, quantity) {
    return fetch(buildUrl('cart/change.js'), {
      method: 'POST',
      cache: 'no-store',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        line: Number(line),
        quantity: Number(quantity)
      })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Could not change cart');
        return res.json();
      })
      .then(function (cart) {
        renderCart(cart);
      })
      .catch(function (err) {
        console.error('Change cart error:', err);
      });
  }

  function isCartAddForm(form) {
    if (!form || form.tagName !== 'FORM') return false;

    var action = form.getAttribute('action') || '';
    return action.indexOf('/cart/add') !== -1;
  }

  function getSubmitButton(form) {
    return form.querySelector('button[type="submit"], input[type="submit"]');
  }

  function setButton(button, text, disabled) {
    if (!button) return;

    if (!button.dataset.originalText) {
      button.dataset.originalText = button.tagName === 'INPUT'
        ? button.value || (SV_ES ? 'Añadir al carrito' : 'Add to cart')
        : button.textContent.trim() || (SV_ES ? 'Añadir al carrito' : 'Add to cart');
    }

    button.disabled = !!disabled;

    if (button.tagName === 'INPUT') {
      button.value = text;
    } else {
      button.textContent = text;
    }
  }

  function resetButton(button) {
    if (!button) return;

    button.disabled = false;

    if (button.tagName === 'INPUT') {
      button.value = button.dataset.originalText || (SV_ES ? 'Añadir al carrito' : 'Add to cart');
    } else {
      button.textContent = button.dataset.originalText || (SV_ES ? 'Añadir al carrito' : 'Add to cart');
    }
  }

  function addToCart(form) {
    if (form.dataset.svAdding === 'true') return;

    form.dataset.svAdding = 'true';

    var button = getSubmitButton(form);
    var formData = new FormData(form);

    var variantId = formData.get('id');
    var quantity = formData.get('quantity') || '1';

    if (!variantId) {
      console.error('No variant ID found in form:', form);
      setButton(button, (SV_ES ? 'Inténtalo de nuevo' : 'Try again'), false);
      form.dataset.svAdding = 'false';

      setTimeout(function () {
        resetButton(button);
      }, 1300);

      return;
    }

    formData.set('id', variantId);
    formData.set('quantity', quantity);

    setButton(button, (SV_ES ? 'Añadiendo...' : 'Adding...'), true);

    return fetch(buildUrl('cart/add.js'), {
      method: 'POST',
      cache: 'no-store',
      body: formData,
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) {
            console.error('Shopify cart/add.js error:', err);
            throw err;
          });
        }

        return res.json();
      })
      .then(function () {
        return new Promise(function (resolve) {
          setTimeout(resolve, 300);
        });
      })
      .then(function () {
        return fetchCart();
      })
      .then(function (cart) {
        renderCart(cart);
        openDrawer();

        setButton(button, (SV_ES ? 'Añadido' : 'Added'), false);
        form.dataset.svAdding = 'false';

        setTimeout(function () {
          resetButton(button);
        }, 1000);
      })
      .catch(function (err) {
        console.error('Add to cart error:', err);

        setButton(button, (SV_ES ? 'Inténtalo de nuevo' : 'Try again'), false);
        form.dataset.svAdding = 'false';

        setTimeout(function () {
          resetButton(button);
        }, 1300);
      });
  }

  injectStyles();
  injectDrawer();

  fetchCart()
    .then(function (cart) {
      renderCart(cart);
    })
    .catch(function (err) {
      console.error('Initial cart fetch error:', err);
    });

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;

      if (!isCartAddForm(form)) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      addToCart(form);
    },
    true
  );

  document.addEventListener('click', function (event) {
    if (
      event.target.closest('[data-sv-cart-close]') ||
      event.target.closest('[data-sv-cart-overlay]')
    ) {
      closeDrawer();
      return;
    }

    var changeButton = event.target.closest('[data-sv-cart-change]');

    if (changeButton) {
      var line = changeButton.getAttribute('data-sv-cart-change');
      var qty = changeButton.getAttribute('data-qty');

      changeCartLine(line, qty);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeDrawer();
    }
  });
})();